export default __webpack_public_path__ + "static/media/picto-recherche.c470d93a.png";